import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useLayoutVariant } from '../context/LayoutVariantContext';

const REFERENCE_DOC_CLASS = 'payzen-reference';

const getLastLogin = () => {
  try {
    const raw = localStorage.getItem('payzen_last_login');
    if (raw) {
      const d = new Date(raw);
      if (!Number.isNaN(d.getTime())) return d.toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }
    return new Date().toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch {
    return new Date().toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }
};

const Layout = ({ children, compactTop = false }) => {
  const { isReference } = useLayoutVariant();

  useEffect(() => {
    const html = document.documentElement;
    if (isReference) html.classList.add(REFERENCE_DOC_CLASS);
    else html.classList.remove(REFERENCE_DOC_CLASS);
    return () => html.classList.remove(REFERENCE_DOC_CLASS);
  }, [isReference]);

  const contentPadding = isReference
    ? 'p-6 md:p-8'
    : (compactTop ? 'px-8 pt-3 pb-8' : 'px-8 pt-4 pb-8');

  return (
    <div className={`min-h-screen ${isReference ? 'layout-reference bg-[#F7FAF9]' : 'bg-[#F8FAFC]'}`}>
      <TopBar />
      <div className="pt-16">
        <Sidebar />
      </div>
      <main className="ml-64 min-h-screen pt-10">
        <div className={`max-w-[1400px] mx-auto animate-fade-in ${contentPadding}`}>
          {children}
        </div>
      </main>
      {isReference && (
        <footer className="border-t border-[#DCE4E0] bg-white mt-12">
          <div className="max-w-[1400px] mx-auto py-8 px-4 flex flex-col md:flex-row items-center justify-between">
            <div className="text-sm text-[#0E1B16] opacity-60">© 2025 PayZen by Anantla Australia Pty Ltd. AUSTRAC Registered.</div>
            <div className="text-xs text-[#0E1B16] opacity-40 mt-2 md:mt-0">Last login: {getLastLogin()}</div>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
